import React from 'react';
import { Chip } from '@mui/material';
import type { TransactionType } from './mockTransactionLog';

const TRANSACTION_TYPE_STYLE: Record<
  TransactionType,
  { label: string; bgcolor: string; textColor: string }
> = {
  ISSUE_OUT: { label: 'ISSUE OUT', bgcolor: 'info.main', textColor: 'common.white' },
  TURN_IN: { label: 'TURN IN', bgcolor: 'success.main', textColor: 'common.white' },
  EXCHANGE: { label: 'EXCHANGE', bgcolor: 'secondary.main', textColor: 'common.white' },
  THR_DUE_DATE_EXTENDED: { label: 'DUE DATE EXTENDED', bgcolor: 'info.main', textColor: 'common.white' },
  THR_TO_PHR_CONVERTED: { label: 'THR → PHR CONVERTED', bgcolor: 'info.main', textColor: 'common.white' },
  DISPOSAL: { label: 'DISPOSAL', bgcolor: 'warning.dark', textColor: 'common.white' },
  TRANSFER: { label: 'TRANSFER', bgcolor: 'info.main', textColor: 'common.white' },
  SHIPMENT: { label: 'SHIPMENT', bgcolor: 'info.main', textColor: 'common.white' },
  MAINTENANCE_SEND: { label: 'MAINTENANCE SEND', bgcolor: 'warning.main', textColor: 'common.white' },
  MAINTENANCE_RECEIVE: { label: 'MAINTENANCE RECEIVE', bgcolor: 'success.main', textColor: 'common.white' },
  DD200: { label: 'FLIPL', bgcolor: 'primary.main', textColor: 'common.white' },
  DA7923: { label: 'STATEMENT OF CHARGES', bgcolor: 'secondary.main', textColor: 'common.white' },
  MFR: { label: 'MFR', bgcolor: 'warning.dark', textColor: 'common.white' },
  DA4949: { label: '4949 ADJUSTMENT', bgcolor: 'warning.dark', textColor: 'common.white' },
  IAR_ADJUSTMENT: { label: 'IAR ADJUSTMENT', bgcolor: 'warning.dark', textColor: 'common.white' },
  PURCHASE_REQUISITION_CREATE: { label: 'PR CREATED', bgcolor: 'info.main', textColor: 'common.white' },
  PURCHASE_REQUISITION_RECEIVE: {
    label: 'PR RECEIVED',
    bgcolor: 'success.main',
    textColor: 'common.white',
  },
  PURCHASE_REQUISITION_CANCEL: {
    label: 'PR CANCELLED',
    bgcolor: 'error.main',
    textColor: 'common.white',
  },
  CORRECTION_FULL_DOCUMENT: {
    label: 'CORRECTION (FULL DOC)',
    bgcolor: 'error.dark',
    textColor: 'common.white',
  },
  CORRECTION_ITEM_LEVEL: {
    label: 'CORRECTION (ITEM)',
    bgcolor: 'error.main',
    textColor: 'common.white',
  },
  NON_RECOVERABLE_CLEAR: {
    label: 'NON-RECOVERABLE',
    bgcolor: 'warning.dark',
    textColor: 'common.white',
  },
  INDIVIDUAL_CLEARED: {
    label: 'CLEARED',
    bgcolor: 'error.main',
    textColor: 'common.white',
  },
  INDIVIDUAL_REACTIVATED: {
    label: 'REACTIVATED',
    bgcolor: 'warning.main',
    textColor: 'common.white',
  },
};

export interface TransactionTypeChipProps {
  value: TransactionType | string;
  cancellationScope?: 'order' | 'line_item';
}

export const TransactionTypeChip: React.FC<TransactionTypeChipProps> = ({
  value,
  cancellationScope,
}) => {
  const config =
    value === 'PURCHASE_REQUISITION_CANCEL' && cancellationScope === 'line_item'
      ? {
          label: 'PR ADJUSTED',
          bgcolor: 'warning.main',
          textColor: 'common.white',
        }
      : (TRANSACTION_TYPE_STYLE[value as TransactionType] ?? {
          label: value.replaceAll('_', ' '),
          bgcolor: 'grey.700',
          textColor: 'common.white',
        });

  return (
    <Chip
      size="small"
      label={config.label}
      sx={{
        bgcolor: config.bgcolor,
        color: config.textColor,
        fontWeight: 700,
        letterSpacing: '0.06em',
        '& .MuiChip-label': {
          px: 1.25,
        },
      }}
    />
  );
};
